<template>
  <v-card class=" mb-2 elevation-0">
    <v-card-subtitle class="">
      <section class="d-flex">
        <h2 class="mb-3">Informações da transportadora</h2>
        <v-btn depressed small color="error" v-on:click="logout()" class="btn-logout">
          <v-icon>exit_to_app</v-icon>Sair
        </v-btn>
      </section>
      <v-divider></v-divider>
    </v-card-subtitle>
    <v-card-text class="d-flex flex-column flex-lg-row flex-sm-column">
      <strong class="mr-2">Razão Social: </strong>
      {{ transportadora.razaosocial }}
      <v-spacer />
      <strong class="mr-2">CNPJ: </strong> {{ transportadora.cnpj | cnpj }}
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import GlobalStore from "@/store/modules/global";
import TransportadoraAuthService from "@/services/transportadora.auth.service";

export default {
  name: "Transportadora",
  methods: {
    logout() {
      TransportadoraAuthService.logout();
    }
  },
  computed: {
    ...mapState("transportadora", ["transportadora"])
  }
};
</script>
